import React from 'react';
import TabListStateless from '@visa/vds/tab-list-stateless';
import NavSite from '@visa/vds/nav-site';
import NavLinks from '@visa/vds/nav-links';
import MCSDesktopNavItem from './MCSDesktopNavItem';
import { addMenuItem } from '_helpers/NavHelper';
import { useAuthContextUser } from '../context/AuthContext';

const MCSDesktopNav = (props) => {
  const user = useAuthContextUser();

  const renderRoutes = function () {    
    let routes = props.siteRoutes;
    let render =[];
    routes.forEach((item, k) => {
      if (addMenuItem(item, user)) {
        var filterChildren = [];
        if (item.children) {
          filterChildren = item.children.filter((childItem, index) => {
            return addMenuItem(childItem, user);
          });
        }

        if (filterChildren.length > 0) {
          render.push(<MCSDesktopNavItem key={k} k={k} item={item} availableChild={filterChildren} selectedTab={props.selectedTab} setSelectedTab={props.setSelectedTab}></MCSDesktopNavItem>)
        }else{
          render.push(<MCSDesktopNavItem key={k} k={k} item={item} selectedTab={props.selectedTab} setSelectedTab={props.setSelectedTab}></MCSDesktopNavItem>)
        }
      }
    });

    return render;
  }

  return (
    <NavSite align="end">
      <NavLinks ariaLabel="VSS desktop menu">
        <TabListStateless role="none">
          {renderRoutes()}
        </TabListStateless>
      </NavLinks>
    </NavSite>
  )
}

export default MCSDesktopNav